const $ = require('jquery');
const slick = require('slick-carousel');

$('.js-facts-carousel').slick({
	infinite: true,
	speed: 300,
	// adaptiveHeight: true,
	autoplay: true,
	prevArrow: '<button type="button" class="c-carousel__rounded-button c-carousel__rounded-button--previous"></button>',
	nextArrow: '<button type="button" class="c-carousel__rounded-button c-carousel__rounded-button--next"></button>',
});

$('.js-facts-carousel').slick('slickFilter', $('.js-bad-quality-facts').parent().parent());

$('.js-filter-facts-carousel').on('click', function()
{
	dataLayer.push({'event':'keyfacts', 'actionDetail':'there-is-hope'});
	// console.log('filter');
	$(this).hide();
	$('.js-facts-carousel').slick('slickUnfilter').slick('slickFilter', $('.js-good-quality-facts').parent().parent());
});

$('.js-dooh-carousel').slick({
    infinite: true,
    // speed: 10000,
    autoplaySpeed: 10000,
    autoplay: true,
    arrows: false,
    pauseOnHover: false,
    pauseOnFocus: false
});
